import React from 'react';
import { IGameReplayAdapter } from '../types';
import { Layers } from 'lucide-react';

export class BidWhistReplayAdapter implements IGameReplayAdapter {
  formatReplayHeader(handData: any): { title: string; subtitle: string; badges: string[] } {
    const contract = handData?.contract || (handData?.winningBid ? `${handData.winningBid} ${handData.direction === 'DOWN' ? '⬇ Downtown' : '⬆ Uptown'} ${handData.trumpSuit || '♠'}` : 'Hand Replay');
    const bidderName = handData?.bidderName || (handData?.bidderTeam ? `Team ${handData.bidderTeam}` : 'Bidder');
    const result = handData?.result || 'COMPLETED';

    const badges: string[] = [];
    if (handData?.winningBid) badges.push(`Bid: ${handData.winningBid}`);
    if (handData?.direction) badges.push(handData.direction === 'DOWN' ? 'Downtown ⬇' : 'Uptown ⬆');
    if (handData?.isNoTrump) badges.push('No-Trump');
    if (handData?.trumpSuit && !handData.isNoTrump) badges.push(`Trump: ${handData.trumpSuit}`);
    if (result) badges.push(result);

    return {
      title: contract,
      subtitle: `Bid by ${bidderName} (${handData?.bidderBooks ?? 0}/${handData?.neededBooks ?? handData?.winningBid ? 6 + handData.winningBid : 10} books won)`,
      badges
    };
  }

  formatTrickOutcome(trick: any, handData: any): string {
    const winningSeat = trick?.winningSeat ?? trick?.winnerSeat;
    const team = (winningSeat === 0 || winningSeat === 2) ? 'Team 1' : 'Team 2';
    const cardStr = trick?.winningCard ? `${trick.winningCard.rank || ''}${trick.winningCard.suit ? ' of ' + trick.winningCard.suit : ''}` : '';
    return `${team} (Seat ${(winningSeat ?? 0) + 1}) won with ${cardStr || 'winning card'}`;
  }

  renderAuxiliaryDrawer(handData: any): React.ReactNode {
    const origKitty = handData?.originalKitty || handData?.kittyCards || [];
    const discards = handData?.kittyDiscards || handData?.discardedCards || [];

    if (!origKitty.length && !discards.length) return null;

    return (
      <div className="flex flex-col gap-2 p-3 bg-black/40 rounded-xl border border-amber-400/20 text-xs">
        <div className="flex items-center gap-1.5 text-amber-300 font-bold uppercase tracking-wider text-[11px]">
          <Layers size={14} className="text-amber-400" />
          <span>Kitty & Blind Discards</span>
        </div>

        {origKitty.length > 0 && (
          <div className="flex flex-col gap-1">
            <span className="text-[10px] text-white/50 uppercase font-mono">Original 6-Card Kitty:</span>
            <div className="flex flex-wrap gap-1.5">
              {origKitty.map((c: any, idx: number) => (
                <div
                  key={c.id || idx}
                  className="px-2 py-0.5 rounded bg-slate-800 border border-white/20 text-white font-mono font-bold text-[11px]"
                >
                  {c.rank || c.id}{c.suit ? ` ${c.suit.charAt(0)}` : ''}
                </div>
              ))}
            </div>
          </div>
        )}

        {discards.length > 0 && (
          <div className="flex flex-col gap-1 mt-1">
            <span className="text-[10px] text-amber-200/60 uppercase font-mono">Discards (Buried):</span>
            <div className="flex flex-wrap gap-1.5">
              {discards.map((c: any, idx: number) => (
                <div
                  key={c.id || idx}
                  className="px-2 py-0.5 rounded bg-amber-950/60 border border-amber-500/30 text-amber-300 font-mono font-bold text-[11px]"
                >
                  {c.rank || c.id}{c.suit ? ` ${c.suit.charAt(0)}` : ''}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}
